
export default class Environment {
 static  apiUrl =  `https://password-api.inmigrausa.com/api`
 //static  apiUrl =`https://password-api.inmigrausa.com/api`
 static groupId = localStorage.getItem('groupId')
 static accountId = localStorage.getItem('accountId')
};

